import type { Dictionary } from '../../i18n/dictionary';
import { plural } from '../../i18n/plural';

/** "45 min", "2 h", "1 h 30 min" — the same in both languages. */
function duration(minutes: number): string {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  if (h === 0) return `${String(m)} min`;
  return m === 0 ? `${String(h)} h` : `${String(h)} h ${String(m)} min`;
}

const pl = {
  appName: 'Przepisy',
  titleSuffix: 'Przepisy — ITLamb',
  recipes: 'Przepisy',

  newRecipe: 'Nowy przepis',
  editRecipe: 'Edytuj przepis',
  search: 'Szukaj',
  searchPlaceholder: 'Nazwa, składnik albo tag',
  tags: 'Tagi',
  empty: 'Nie masz jeszcze żadnych przepisów.',
  addFirst: 'Dodaj pierwszy przepis',
  noMatch: 'Żaden przepis nie pasuje.',

  name: 'Nazwa',
  servings: 'Porcje',
  minutes: 'Czas (min)',
  ingredients: 'Składniki',
  steps: 'Przygotowanie',
  notes: 'Notatki',
  ingredient: (n: number) => `Składnik ${String(n)}`,
  step: (n: number) => `Krok ${String(n)}`,
  addIngredient: 'Dodaj składnik',
  addStep: 'Dodaj krok',
  moveUp: 'Przesuń w górę',
  moveDown: 'Przesuń w dół',
  removeLine: 'Usuń',
  removeTag: (tag: string) => `Usuń tag ${tag}`,
  save: 'Zapisz',
  saving: 'Zapisywanie…',
  cancel: 'Anuluj',
  edit: 'Edytuj',
  back: 'Wszystkie przepisy',
  deleteRecipe: 'Usuń przepis',
  confirmDelete: (name: string) => `Usunąć przepis „${name}”?`,

  servingsCount: (n: number) =>
    `${String(n)} ${plural(n, 'porcja', 'porcje', 'porcji')}`,
  duration,

  loadFailed: 'Nie udało się wczytać przepisów.',
  createFailed: 'Nie udało się dodać przepisu.',
  updateFailed: 'Nie udało się zapisać przepisu.',
  deleteFailed: 'Nie udało się usunąć przepisu.',
  created: 'Przepis dodany.',
  updated: 'Przepis zapisany.',
};

const en: typeof pl = {
  appName: 'Recipes',
  titleSuffix: 'Recipes — ITLamb',
  recipes: 'Recipes',

  newRecipe: 'New recipe',
  editRecipe: 'Edit recipe',
  search: 'Search',
  searchPlaceholder: 'Name, ingredient or tag',
  tags: 'Tags',
  empty: "You don't have any recipes yet.",
  addFirst: 'Add your first recipe',
  noMatch: 'No recipe matches.',

  name: 'Name',
  servings: 'Servings',
  minutes: 'Time (min)',
  ingredients: 'Ingredients',
  steps: 'Method',
  notes: 'Notes',
  ingredient: (n) => `Ingredient ${String(n)}`,
  step: (n) => `Step ${String(n)}`,
  addIngredient: 'Add ingredient',
  addStep: 'Add step',
  moveUp: 'Move up',
  moveDown: 'Move down',
  removeLine: 'Remove',
  removeTag: (tag) => `Remove tag ${tag}`,
  save: 'Save',
  saving: 'Saving…',
  cancel: 'Cancel',
  edit: 'Edit',
  back: 'All recipes',
  deleteRecipe: 'Delete recipe',
  confirmDelete: (name) => `Delete the recipe "${name}"?`,

  servingsCount: (n) =>
    `${String(n)} ${plural(n, 'serving', 'servings', 'servings')}`,
  duration,

  loadFailed: 'Could not load recipes.',
  createFailed: 'Could not add the recipe.',
  updateFailed: 'Could not save the recipe.',
  deleteFailed: 'Could not delete the recipe.',
  created: 'Recipe added.',
  updated: 'Recipe saved.',
};

export const recipesDict: Dictionary<typeof pl> = { pl, en };
